/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes — turn off "Allow duplicates" and each number can only appear once, like drawing lottery balls without replacement. The result is capped at the size of your range: asking for 20 unique numbers between 1 and 10 will only return 10. Leave duplicates on when you want independent draws, such as simulating dice rolls.`)
};

const es_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí — desactiva "Permitir duplicados" y cada número puede aparecer solo una vez, como sacar bolas de lotería sin reemplazo. El resultado se limita al tamaño de tu rango: pedir 20 números únicos entre 1 y 10 solo devolverá 10. Deja duplicados activados cuando quieras sorteos independientes, como simular lanzamientos de dados.`)
};

const de_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — schalte "Duplikate erlauben" aus und jede Zahl kann nur einmal vorkommen, wie das Ziehen von Lotteriekugeln ohne Zurücklegen. Das Ergebnis ist auf die Größe deines Bereichs begrenzt: 20 eindeutige Zahlen zwischen 1 und 10 ergeben nur 10. Lasse Duplikate an, wenn du unabhängige Draws möchtest, z. B. um Würfelwürfe zu simulieren.`)
};

const nl_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja — schakel "Duplicaten toestaan" uit en elk getal kan maar eens verschijnen, zoals het trekken van lottoballen zonder vervanging. Het resultaat wordt beperkt tot de grootte van uw bereik: het aanvragen van 20 unieke getallen tussen 1 en 10 levert slechts 10 op. Laat duplicaten aan wanneer u onafhankelijke trekkingen wilt, zoals het simuleren van dobbelsteenworpen.`)
};

const fr_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui — désactivez "Autoriser les doublons" et chaque nombre ne peut apparaître qu'une seule fois, comme tirer des boules de loterie sans remplacement. Le résultat est limité à la taille de votre plage : demander 20 nombres uniques entre 1 et 10 ne renverra que 10. Laissez les doublons activés quand vous voulez des tirages indépendants, comme simuler des lancers de dés.`)
};

const it_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì — disattiva "Consenti duplicati" e ogni numero può apparire solo una volta, come estrarre palline della lotteria senza rimpiazzo. Il risultato è limitato alla dimensione del tuo intervallo: chiedere 20 numeri univoci tra 1 e 10 restituirà solo 10. Lascia i duplicati attivati quando vuoi estrazioni indipendenti, come simulare lanci di dadi.`)
};

const pt_br2_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — desligue "Permitir duplicatas" e cada número pode aparecer apenas uma vez, como desenhar bolas de loteria sem reposição. O resultado é limitado ao tamanho do seu intervalo: pedir 20 números únicos entre 1 e 10 retornará apenas 10. Deixe as duplicatas ativadas quando você quiser sorteios independentes, como simular lançamentos de dados.`)
};

const pt_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim — desligue "Permitir duplicados" e cada número pode aparecer apenas uma vez, como tirar bolas de lotaria sem reposição. O resultado é limitado ao tamanho do seu intervalo: pedir 20 números únicos entre 1 e 10 devolverá apenas 10. Deixe duplicados ligados quando pretender sorteios independentes, como simular lances de dados.`)
};

const ja_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。「重複を許可」をオフにすると、各番号は1回だけ表示されます。これは置換なしで宝くじボールを引くようなものです。結果は範囲のサイズに限定されます。1〜10の間で20個の一意の番号を要求すると、10個しか返されません。サイコロの振のシミュレーションなど、独立した抽選が必要な場合は、重複をオンのままにしてください。`)
};

const zh_rg_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以——关闭“允许重复”后，每个数字只能出现一次，就像不放回地抽取彩票球一样。结果数量上限为你所设范围的大小：若要求在1到10之间生成20个不重复的数字，只会返回10个。若需要独立抽取（例如模拟掷骰子），请保持重复选项开启。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_faq3_a", locale)
	if (locale === "en") return en_rg_faq3_a(inputs)
	if (locale === "es") return es_rg_faq3_a(inputs)
	if (locale === "de") return de_rg_faq3_a(inputs)
	if (locale === "nl") return nl_rg_faq3_a(inputs)
	if (locale === "fr") return fr_rg_faq3_a(inputs)
	if (locale === "it") return it_rg_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_rg_faq3_a(inputs)
	if (locale === "pt") return pt_rg_faq3_a(inputs)
	if (locale === "ja") return ja_rg_faq3_a(inputs)
	return zh_rg_faq3_a(inputs)
};